window.io = require('socket.io-client')

let { protocol, hostname, port } = document.location
let url = `${protocol}//${hostname}`
if(!PRODUCTION) {
  if(hostname == 'localhost' && port == 3000) {
    port = 6001
  }
  if(port) url += `:${port}`
}

import Echo from 'laravel-echo'
window.Echo = new Echo({
  broadcaster: 'socket.io',
  // key: '53ab32c6d8883001b68f43f224e14017'
  // host: { path: '/socket.io' },
  host: url
})